import React, { useEffect, useState } from "react";
import styles from "./time-series-data-type.module.scss";
import { useI18N } from "@src/language/language-context";

interface TimeSeriesDataTypePropTypes {
  dataType: string | undefined;
}

const cssClassName = "time-series-data-type";

export const TimeSeriesDataType = ({
  dataType,
}: TimeSeriesDataTypePropTypes) => {
  const i18n = useI18N();
  const [localDataType, setLocalDataType] = useState(undefined);

  const texts = {
    dataTypeText: i18n("modules.timeSeriesDataType.dataTypeText"),
  };

  useEffect(() => {
    const returnDataType = (dataType: string | null | undefined) => {
      if (dataType === undefined) {
        return "Loading...";
      } else if (dataType === null) {
        return "Data type not available";
      } else {
        return dataType;
      }
    };

    setLocalDataType(returnDataType(dataType));
  }, [dataType]);

  return (
    <div className={styles[cssClassName]}>
      <div className={styles[`${cssClassName}__attribute-name`]}>
        {texts.dataTypeText}
      </div>
      <div className={styles[`${cssClassName}__data-type`]}>
        {localDataType}
      </div>
    </div>
  );
};
